<template>

    <div class="card card-profile mt-5">
        <div class="card-avatar">
            <img :src="userPicture" style="width:130px;height:130px;">
        </div>
        <div :class="'card-body text-'+align">
            <h4 class="card-title mb-3 text-center font-weight-bold" v-html="userName"></h4>
            <slot></slot>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            align:  {default: 'left'},
            userName:  {default: ''},
            userPicture: {default: app_url + 'polaris/img/lib/misc/avatar.jpg'},
        }
    }
</script>
